import React from 'react';

/* A note when using this component - if you not pass a fill color the icon will use the default fill color. */

const IconFacebookVerifiedBadge = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <path
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'evenodd',
        stroke: 'none',
      }}
      d="M534.286 429.505a177.143 177.143 0 1 1-354.286 0 177.143 177.143 0 1 1 354.286 0z"
      transform="matrix(.06111 0 0 .06111 -10.904 -15.17)"
    />
    <path
      style={{
        fill: !props.fill ? '#5890ff' : props.fill,
        fillOpacity: 1,
        fillRule: 'evenodd',
        stroke: 'none',
      }}
      d="M534.286 429.505a177.143 177.143 0 1 1-354.286 0 177.143 177.143 0 1 1 354.286 0z"
      transform="matrix(.05363 0 0 .05363 -8.264 -12.05)"
    />
    <path
      style={{
        fill: '#fff',
        fillOpacity: 1,
        stroke: 'none',
      }}
      d="m357.444 430.148-2.786-2.785-1.665 1.703 4.405 4.58 7.824-8.146-1.795-1.841z"
      transform="translate(-347.643 -417.005)"
    />
  </svg>
);

export default IconFacebookVerifiedBadge;
